export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7227.c8abbce6.jpg";